<template>
  <img :src="imageSrc" :alt="alt" />
</template>

<script>
import { LANG_EN } from "@/js/local-name";

export default {
  name: "I18nImage",
  props: {
    filename: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: "",
    },
  },
  computed: {
    imageSrc() {
      return this.$i18n.locale === LANG_EN
        ? require(`@/assets/images-en/${this.filename}`)
        : require(`@/assets/images/${this.filename}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/I18nImage.vue